"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyPasteSummaryCell = copyPasteSummaryCell;
exports.cutPasteSummaryCell = cutPasteSummaryCell;
exports.deleteSummaryCell = deleteSummaryCell;
const common_1 = require("../common/common");
async function copyPasteSummaryCell(activeUserId, activeBranchId, data) {
    try {
        const url = `/dashboard/${activeUserId}/summary/copy_and_paste?c=${activeBranchId}`;
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data)
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function cutPasteSummaryCell(activeUserId, activeBranchId, data) {
    try {
        const url = `/dashboard/${activeUserId}/summary/cut_and_paste?c=${activeBranchId}`;
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data)
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function deleteSummaryCell(activeUserId, activeBranchId, slotIds) {
    const url = `/dashboard/${activeUserId}/summary/bulk_delete?c=${activeBranchId}`;
    const data = {
        action: common_1.SlotBulkDeleteAction.Selected,
        selectedSlots: slotIds.join(","),
    };
    const response = await fetch(url, {
        method: "POST",
        body: new URLSearchParams(data),
    });
    return response.json();
}
